import { RotateCcw, Check, CloudUpload } from "lucide-react";

const ago = (iso) => {
  if (!iso) return "";
  const m = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (m < 1) return "just now";
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.round(h / 24)}d ago`;
};

/** Shows "Draft restored · Start fresh" after a restore, and a subtle autosave indicator otherwise. */
export function DraftBar({ draft, onStartFresh, className = "" }) {
  const { restoredAt, status } = draft;
  if (restoredAt) {
    return (
      <div className={`flex items-center justify-between gap-3 flex-wrap px-4 py-2.5 rounded-xl bg-nexus-blue/10 border border-nexus-blue/25 text-sm ${className}`} data-testid="draft-restored-bar">
        <div className="flex items-center gap-2 text-zinc-200">
          <RotateCcw className="h-4 w-4 text-nexus-blue shrink-0" />
          <span>We restored your unsaved draft from <b className="text-white">{ago(restoredAt)}</b>. Pick up where you left off.</span>
        </div>
        <button type="button" onClick={onStartFresh} className="text-xs font-semibold text-zinc-300 hover:text-white underline underline-offset-2" data-testid="draft-start-fresh-btn">Start fresh</button>
      </div>
    );
  }
  if (status === "idle") return null;
  return (
    <div className={`flex items-center gap-1.5 text-[11px] text-zinc-500 ${className}`} data-testid="draft-autosave-status" data-status={status}>
      {status === "saving" ? <CloudUpload className="h-3 w-3 animate-pulse" /> : <Check className="h-3 w-3 text-emerald-400" />}
      {status === "saving" ? "Saving draft…" : "Draft saved — safe to leave and come back"}
    </div>
  );
}
